import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-user-profile',
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    ButtonModule,
    InputTextModule
  ],
  templateUrl: './user-profile.html',
  styleUrl: './user-profile.css'
})
export class UserProfile implements OnInit {
  profile = {
    fullName: 'Raveendar',
    displayName: 'Raveendar',
    email: 'raveendar@virtukart.com',
    gender: 'prefer-not-to-say',
    state: 'Telangana',
    country: 'India',
    timezone: 'Asia/Kolkata',
    language: 'en-US'
  };

  isEditing = false;

  genderOptions = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Other', value: 'other' },
    { label: "I'd prefer not to say", value: 'prefer-not-to-say' }
  ];

  countryOptions = [
    { label: 'India', value: 'India', flag: '🇮🇳' },
    { label: 'United States', value: 'United States', flag: '🇺🇸' },
    { label: 'United Kingdom', value: 'United Kingdom', flag: '🇬🇧' }
  ];

  languageOptions = [
    { label: 'English - United States', value: 'en-US' },
    { label: 'English - United Kingdom', value: 'en-GB' },
    { label: 'Hindi', value: 'hi-IN' }
  ];

  timezoneOptions = [
    { label: '(GMT +05:30) India Standard Time (Asia/Kolkata)', value: 'Asia/Kolkata' },
    { label: '(GMT -05:00) Eastern Time (America/New_York)', value: 'America/New_York' },
    { label: '(GMT +00:00) Greenwich Mean Time (Europe/London)', value: 'Europe/London' }
  ];

  emails = [
    {
      address: 'raveendar@virtukart.com',
      verified: true,
      primary: true,
      addedDate: '9 years ago',
      providers: ['w', 'google']
    }
  ];

  ngOnInit() {
    // Initialize component
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  saveProfile() {
    // Save profile logic here
    console.log('Saving profile:', this.profile);
    this.isEditing = false;
  }

  cancelEdit() {
    // Reset to original values
    this.isEditing = false;
  }

  addEmailAddress() {
    // Add email logic here
    console.log('Add email address clicked');
  }

  getCountryFlag(country: string): string {
    const flag = this.countryOptions.find(option => option.value === country)?.flag;
    return flag || '🌍';
  }
}